export default function LogoWellfound() {
  return (
    <svg
      width="174"
      height="23"
      viewBox="0 0 174 23"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M170.382 22.5302C171.902 22.5302 173.135 21.3043 173.135 19.7922C173.135 18.2801 171.902 17.0542 170.382 17.0542C168.862 17.0542 167.629 18.2801 167.629 19.7922C167.629 21.3043 168.862 22.5302 170.382 22.5302Z"
        fill="currentColor"
      />
      <path
        d="M170.382 11.3439C171.902 11.3439 173.135 10.1181 173.135 8.60593C173.135 7.09377 171.902 5.86795 170.382 5.86795C168.861 5.86795 167.629 7.09377 167.629 8.60593C167.629 10.1181 168.861 11.3439 170.382 11.3439Z"
        fill="currentColor"
      />
      <path
        d="M59.9301 18.9826V22.3279H47.6327V18.9826H51.7245V3.49232H47.6327V0.136444H55.8701V18.9826H59.9301Z"
        fill="currentColor"
      />
      <path
        d="M74.6807 18.9826V22.3279H62.3833V18.9826H66.4751V3.49232H62.3833V0.136444H70.6207V18.9826H74.6807Z"
        fill="currentColor"
      />
      <path
        d="M79.6292 22.3279V9.40505H75.7087V6.05983H79.6292V4.73879C79.6292 1.75579 81.1932 0.136444 84.4282 0.136444H89.0881V3.4284H85.1247C84.1283 3.4284 83.6999 3.86519 83.6999 4.84531V6.04917H89.0881V9.39439H83.7536V22.3172H79.6292V22.3279Z"
        fill="currentColor"
      />
      <path
        d="M98.7191 5.86795C93.7378 5.86795 90.3743 9.21317 90.3743 14.199C90.3743 19.1849 93.7378 22.5301 98.7191 22.5301C103.7 22.5301 107.096 19.1956 107.096 14.199C107.096 9.20251 103.732 5.86795 98.7191 5.86795ZM98.7191 19.1423C96.2123 19.1423 94.5843 17.0755 94.5843 14.199C94.5843 11.3226 96.2123 9.25577 98.7191 9.25577C101.226 9.25577 102.886 11.3119 102.886 14.199C102.886 17.0862 101.247 19.1423 98.7191 19.1423Z"
        fill="currentColor"
      />
      <path
        d="M120.935 6.05994H125.059V22.328H121.042V20.3464C120.003 21.5716 118.579 22.5197 116.275 22.5197C112.955 22.5197 109.945 20.8151 109.945 15.254V6.05994H114.069V14.9237C114.069 17.6297 115.065 19.1319 117.314 19.1319C119.564 19.1319 120.946 17.4912 120.946 14.5402V6.05994H120.935Z"
        fill="currentColor"
      />
      <path
        d="M159.509 0.136444V8.02009C158.47 6.75231 156.874 5.85742 154.635 5.85742C150.319 5.85742 146.998 9.13872 146.998 14.1566C146.998 19.1744 150.19 22.5089 154.55 22.5089C156.938 22.5089 158.534 21.3903 159.595 19.9734V22.3172H163.612V0.136444H159.499H159.509ZM155.406 19.1424C152.857 19.1424 151.218 17.1076 151.218 14.1992C151.218 11.2907 152.857 9.2559 155.406 9.2559C157.956 9.2559 159.573 11.3014 159.573 14.2418C159.573 17.1821 157.935 19.1531 155.406 19.1531V19.1424Z"
        fill="currentColor"
      />
      <path
        d="M5.87753 22.328L0.800049 6.05994H5.52403L8.52341 17.7576L11.7799 6.05994H16.5253L19.7817 17.7576L22.7811 6.05994H27.5051L22.3633 22.3386H17.3287L14.1472 10.5877L10.9015 22.3386H5.87753V22.328Z"
        fill="currentColor"
      />
      <path
        d="M45.1798 15.1474C45.2546 14.6467 45.2868 14.0501 45.2868 13.6666C45.2439 8.88314 42.0088 5.85754 37.2421 5.85754C32.4753 5.85754 29.0688 9.17079 29.0688 14.2206C29.0688 19.2704 32.2825 22.5197 37.542 22.5197C41.7733 22.5197 44.537 20.0161 45.0617 16.8307H40.9913C40.5736 18.4714 39.256 19.3449 37.3814 19.3449C35.0247 19.3449 33.4608 17.8002 33.3644 15.3286V15.1474H45.1798ZM37.2743 8.98969C39.331 8.98969 40.7662 10.1509 41.1091 12.2284H33.4929C33.7929 10.2255 35.3354 8.98969 37.2743 8.98969Z"
        fill="currentColor"
      />
      <path
        d="M133.168 22.3277H129.044V6.0597H133.061V8.04129C134.1 6.8161 135.525 5.86795 137.828 5.86795C141.149 5.86795 144.159 7.5725 144.159 13.1337V22.3277H140.035V13.4639C140.035 10.7579 139.039 9.25577 136.789 9.25577C134.539 9.25577 133.158 10.8964 133.158 13.8475V22.3384L133.168 22.3277Z"
        fill="currentColor"
      />
    </svg>
  );
}
